export default "__VITE_ASSET__DljyelFS__"